import React, {useEffect} from 'react'
import { useState } from 'react'
import {Link, useLoaderData} from "react-router";
import {CalendarDaysIcon, ClockIcon, MusicalNoteIcon, PencilIcon, PlayCircleIcon} from '@heroicons/react/24/outline';
import {VlogPlayer} from "../../models/vlogs/player";

const Transcription = props => {
  const { transcript, currentTimestamp } = props

  return <div className="flex flex-col gap-4 font-[Axiforma_Regular]">
    {transcript.timestamps.map(timestamp =>
      <div
        key={timestamp.id}
        id={`cushvlog-timestamp-${timestamp.id}`}
        className={`p-2 rounded ${currentTimestamp.id === timestamp.id ? 'bg-gray-300' : ''}`}>
        {timestamp.transcription}
      </div>
    )}
  </div>
}

const loadScript = (src, attrs, parentNode) => new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.async = true
    script.src = src

    for (const [k, v] of Object.entries(attrs || {})) {
      script.setAttribute(k, v)
    }

    script.onload = () => {
      script.onerror = script.onload = null
      resolve(script)
    }

    script.onerror = () => {
      script.onerror = script.onload = null
      reject(new Error(`Failed to load ${src}`))
    }

    const node = parentNode || document.head || document.getElementsByTagName('head')[0]
    node.appendChild(script)
  })

const getCurrentTimestamp = (transcript, time) => {
  return transcript.timestamps.find(timestamp => time >= timestamp.start_seconds &&
    time <= timestamp.finish_seconds
  ) || {}
}

const scrollToTimestamp = (timestamp) => {
  const foundEl = document.querySelector(`#cushvlog-timestamp-${timestamp.id}`)
  foundEl.scrollIntoView({ behavior: 'smooth' })
}

export const VlogDashboard = props => {
  const {vlog, transcript} = useLoaderData()
  const [player, setPlayer] = useState()
  const [playerState, setPlayerState] = useState()
  const [ready, setReady] = useState(false)
  const [currentTimestamp, setCurrentTimeStamp] = useState({})

  // useEffect(() => {
  //   let interval;
  //
  //   if (currentTimestamp.id) {
  //     scrollToTimestamp(currentTimestamp)
  //
  //     const interval = setInterval(
  //       () => setCurrentTimeStamp(getCurrentTimestamp(transcript, player.getCurrentTime())),
  //       1000
  //     )
  //   }
  //
  //   return () => clearInterval(interval)
  // }, [currentTimestamp.id])

  return <div className="flex flex-col gap-6 absolute w-full h-full top-0 left-0">
      <div className="flex flex-col gap-6 items-center">
        <VlogPlayer vlog={vlog} transcript={transcript} />
      </div>
    </div>
}
